import classNames from 'classnames';
import React from 'react';
import {
	IChatCommandWidgetIframeData,
	IChatCommandWidgetMessage,
} from '@enuan/chat__utils';
import { useMessageContext } from '../../message/message.context';
import { IFrame } from '../../message/content/Iframe';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import { Message } from '../../UI/Message/Message';
import { styled } from '@mui/material/styles';
import type { IOptionalMessageProps } from '../../UI/Message/Message';

type IIframeMessageContent =
	IChatCommandWidgetMessage<IChatCommandWidgetIframeData>;

export const IframeMessage = styled(
	React.forwardRef<HTMLElement, { className?: string } & IOptionalMessageProps>(
		function IframeMessage({ className, ...messageProps }, ref) {
			const { message } = useMessageContext<IIframeMessageContent>();
			const messageClassName = useBlockMessageClassNames();

			return (
				<Message
					{...messageProps}
					ref={ref}
					message={message}
					className={classNames(className, messageClassName, 'message--iframe')}
					customHeader={null}
					customAvatar={null}
				>
					<IFrame />
				</Message>
			);
		},
	),
	{ label: 'IframeMessage', target: 'IframeMessage-root' },
)({
	gridTemplateColumns: '0 1fr 0',
	marginTop: '0.175em',
	marginLeft: 0,
	marginRight: 0,
	padding: 0,
	gap: 0,
	'& .Message-balloon': {
		borderRadius: '0 !important',
		width: '100%',
	},
	'& .message__footer': {
		marginLeft: '20px',
	},
	'&.message--newest .message__footer': {
		justifySelf: 'flex-end',
		marginRight: '20px',
	},
	'& + .message--right': {
		marginBottom: '0.175em !important',
	},
});
